/**
 * Arquivo: src/pages/TrocaSenhaObrigatoria.tsx
 * Versão: 6.0.0
 * Data: 08/10/2026
 */
import { FormEvent, useState } from 'react'
import { Eye, EyeOff, KeyRound } from 'lucide-react'
import { trocarMinhaSenha } from '../services/auth'
import { neonAuth } from '../services/neonAuth'

type Props = {
  email?: string
  onConcluida: () => Promise<void> | void
}

export default function TrocaSenhaObrigatoria({ email, onConcluida }: Props) {
  const [senha,setSenha] = useState('')
  const [confirmacao,setConfirmacao] = useState('')
  const [mostrar,setMostrar] = useState(false)
  const [erro,setErro] = useState('')
  const [busy,setBusy] = useState(false)

  async function salvar(event:FormEvent) {
    event.preventDefault()
    setErro('')
    if (senha.length < 8) {
      setErro('A nova senha deve possuir pelo menos 8 caracteres.')
      return
    }
    if (senha !== confirmacao) {
      setErro('A confirmação da senha não confere.')
      return
    }

    setBusy(true)
    try {
      await trocarMinhaSenha(senha)
      await onConcluida()
    } catch (e) {
      setErro(e instanceof Error ? e.message : 'Não foi possível alterar a senha.')
    } finally {
      setBusy(false)
    }
  }

  return <div className="login-page">
    <form className="login-card password-change-card" onSubmit={salvar}>
      <div className="password-change-icon"><KeyRound size={24}/></div>
      <h1>Crie sua nova senha</h1>
      <p className="password-change-intro">Antes de acessar o sistema, defina uma senha pessoal.</p>
      {email&&<div className="password-change-email">{email}</div>}

      <label>Nova senha</label>
      <div className="password-field">
        <input value={senha} onChange={e=>setSenha(e.target.value)} type={mostrar?'text':'password'} autoComplete="new-password" required/>
        <button type="button" className="password-toggle" onClick={()=>setMostrar(v=>!v)} aria-label={mostrar?'Ocultar senha':'Mostrar senha'}>
          {mostrar?<EyeOff size={20}/>:<Eye size={20}/>}
        </button>
      </div>

      <label>Confirmar nova senha</label>
      <input value={confirmacao} onChange={e=>setConfirmacao(e.target.value)} type={mostrar?'text':'password'} autoComplete="new-password" required/>

      {erro&&<div className="error-box">{erro}</div>}
      <button className="primary-button" disabled={busy}>{busy?'Salvando...':'Salvar nova senha'}</button>
      <button type="button" className="button ghost" disabled={busy} onClick={()=>void neonAuth.signOut()}>Sair</button>
    </form>
  </div>
}
